import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FiHome, FiBookOpen, FiLayers, FiActivity, FiFileText, FiBell, FiUsers, FiSettings } from 'react-icons/fi';
import StudentSwitcher from '../StudentSwitcher';
import { useAuth } from '../../../contexts/AuthContext';
import './ParentSidebar.css';

const navItems = [
  { to: '/parent/overview', icon: FiHome, label: 'Overview' },
  { to: '/parent/assignments', icon: FiBookOpen, label: 'Assignments' },
  { to: '/parent/courses', icon: FiLayers, label: 'Courses' },
  { to: '/parent/activity', icon: FiActivity, label: 'Activity' },
  { to: '/parent/reports', icon: FiFileText, label: 'Reports' },
  { to: '/parent/alerts', icon: FiBell, label: 'Alerts' },
  { to: '/parent/students', icon: FiUsers, label: 'Students' },
  { to: '/parent/settings', icon: FiSettings, label: 'Settings' },
];

function ParentSidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <aside className="parent-sidebar" aria-label="Parent Portal navigation">
      <div className="parent-sidebar__header">
        <div className="parent-sidebar__logo">
          <img src="/logos/docuhounds-logo.svg" alt="DocuHounds" className="parent-sidebar__logo-img" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }} />
          <span className="parent-sidebar__logo-text" style={{ display: 'none' }}>DocuHounds</span>
        </div>
        <span className="parent-sidebar__badge">Parent Portal</span>
      </div>

      <div className="parent-sidebar__switcher">
        <StudentSwitcher />
      </div>

      <nav className="parent-sidebar__nav">
        {navItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `parent-sidebar__item ${isActive ? 'parent-sidebar__item--active' : ''}`
            }
          >
            <item.icon className="parent-sidebar__item-icon" size={18} />
            <span className="parent-sidebar__item-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="parent-sidebar__footer">
        <button
          className="parent-sidebar__logout"
          onClick={async () => {
            await logout();
            navigate('/login');
          }}
        >
          Sign Out
        </button>
      </div>
    </aside>
  );
}

export default ParentSidebar;
